import { render, staticRenderFns } from "./ModalUpdate.vue?vue&type=template&id=d4a20bbc&scoped=true"
import script from "./ModalUpdate.vue?vue&type=script&lang=js"
export * from "./ModalUpdate.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdate.vue?vue&type=style&index=0&id=d4a20bbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a20bbc",
  null
  
)

export default component.exports